import { render, staticRenderFns } from "./viewScreen.vue?vue&type=template&id=dab0e5b8&"
import script from "./viewScreen.vue?vue&type=script&lang=js&"
export * from "./viewScreen.vue?vue&type=script&lang=js&"
import style0 from "./viewScreen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports